import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { BodyEnvio4 } from 'src/app/interfaces/body-envio4';
import { BodyCargaPlanes } from 'src/app/interfaces/body_cargaPlanes';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';
import { PlanModels } from 'src/app/models/plan_models';
import { DataLayerService } from 'src/app/services/dataLeyer/data-leyer.service';
import { OrquestadorService } from 'src/app/services/orquestador/orquestador.service';
import { environment } from 'src/environments/environment';
import { TIEMPO_INACTIVO, FIN_FLUJO_NO, RESUMEN_COMPRA, ERROR } from 'src/app/routes.constants';
import { ERROR_500_REDIRECT } from '@app/shared/final-pages/final-pages.constants';

@Component({
  selector: 'app-arma-plan-no',
  standalone: false,
  templateUrl: './arma-plan-no.component.html',
  styleUrl: './arma-plan-no.component.scss'
})
export class ArmaPlanNoComponent implements OnInit {
  @ViewChild('swServicios') swServicios!: ElementRef;
  @ViewChild('swAsistencia') swAsistencia!: ElementRef;

  // Tiempo local de renovación 
  localTimer = environment.LOCAL_TIMER;
  // Cuanta las veces que es invocado el servicio de refrescado de token
  countRefresh = 0;
  // Verifica si hay actividad
  isActivity = false;
  // Intervalo para detectar movimiento del cursor
  isMouseMove: any;
  checador: any;
  saliendo: boolean = false;
  leadId: string = '';
  sessionId: string = '';
  codAsesor: string = '';
  IdBitacora: string = '';

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    let posicionX, posicionY, nuevaPosicionY, nuevaPosicionX;
    this.isActivity = true;
    nuevaPosicionX = e.clientX;
    nuevaPosicionY = e.clientY;

    if (this.isActivity && (nuevaPosicionX !== posicionX || nuevaPosicionY !== posicionY)) {
      clearTimeout(this.checador);
      this.checador = setTimeout(() => {

        if (this.saliendo == false) {
          this.isActivity = false;
          this.saliendo = true;
          clearInterval(this.isMouseMove);
          clearTimeout(this.checador);
          this.router.navigate([TIEMPO_INACTIVO, { codigoAsesor: this.codAsesor, idLead: this.leadId, porcPll: '25.1', msnPll: 'tiempo inactivo_tarifa', infoViaje: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
        }
      }, this.localTimer);
    }

    posicionX = e.clientX;
    posicionY = e.clientY;
  }

  formulario: FormGroup = new FormGroup({
    swServicios: new FormControl(false, [Validators.required]),
    swAsistencia: new FormControl(false, [Validators.required])
  });

  public datosGenerales: DatosGeneralesModel = {
    Cliente: {
      cedulaCliente: '',
      celularCliente: '',
      nombreCliente: '',
      tipoIdentificacion: ''
    },
    InfoArrendamiento: {
      tipoPropiedad: '',
      ubicacion: '',
      valorAdministracion: 0,
      valorArriendo: 0,
      fechaContrato: '',
      duracionContrato: '',
      ServiciosPublicos: false,
      PaquetesAsistencia: false
    },
    Propietario: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      paisNacimiento: '',
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      fechaExpedicion: '',
      correo: ''
    },
    PlanSeleccionado: {
      plan: '',
      valorPlan: 0
    },
    Inmueble: {
      ciudad: '',
      direccion: '',
      maticula: ''
    },
    Inquilino: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      numCelular: '',
      correo: '',
      paisNacimento: '',
      fechaNacimento: '',
      tipoidentificacion: '',
      documentoIdentidad: '',
      fechaExpedicion: '',
      ciudad: '',
      direccion: ''
    },
    ResponseRiesgoConsultable: [
      {
        esRiesgo: false,
        tipoValidacion: '',
        mensajeValidacion: '',
        idRegistroValidacion: ''
      }
    ]
  }

  json: string = '';
  jsonFinal: string = '';
  nombreTextoPrincipal: string = '';
  textoInferior: string = '';
  private parametro: string = '';
  swCheckServicio: boolean = false;
  swCheckAsistencia: boolean = false;
  valorPlan: number = 0;
  servicioPublico: number = 0;
  paqueteAsistencia: number = 0;
  canonArrendamiento: number = 0;

  planes: PlanModels = {
    data: [{
      coverages: [{
        detail: '',
        name: '',
        price: 0
      }],
      planName: '',
      price: 0
    }],
    error: false
  };

  dataEnvio: BodyEnvio4 = {
    optionalProducts: {
      PRD_CoverageAsistence: false,
      PRD_CoveragePublicServices: false
    },
    productFamily: '',
    leadId: '',
    SessionId: '',
    asesorCode: '',
    bitacoraId: '',
    screenPercentage: '',
    productsConfigurationData: {
      ProductCode: '',
      PolicyHolder: {
        LastName: '',
        MobilePhone: '',
        PersonalDataAuthorization: false
      },
      Property: {
        AdministrationValue: 0,
        ContractStartDate: '',
        Department: '',
        RentalFee: 0,
        TemporaryContracted: '',
        UseProperty: '',
        CityProperty: ''
      },
      Tenant: {
        DocumentNumber: '',
        DocumentType: ''
      }
    }
  }

  dataCarga: BodyCargaPlanes = {
    getPriceData: false,
    productsConfigurationData: {
      Property: {
        AdministrationValue: 0,
        Department: '',
        RentalFee: 0,
        TemporaryContracted: ''
      }
    }
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private orquestadorService: OrquestadorService,
    private _dataLayerService: DataLayerService
  ) { }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  ngOnInit(): void {
    this.sessionId = this.getLocalStorage().toString();

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.getAll('idLead')[0];
      const resultado = params.get('infoCliente');
      this.codAsesor = params.getAll('codigoAsesor')[0];
      this.IdBitacora = params.getAll('bitacoraId')[0];

      if (resultado !== null) {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
        this.datosGenerales = JSON.parse(this.jsonFinal);
        this.parametro = JSON.stringify(this.datosGenerales);

        this.nombreTextoPrincipal = this.datosGenerales.Cliente.nombreCliente + ", arma un plan a tu medida";
        this.textoInferior = "Selecciona las coberturas que quieres incluir";
      }
      else {
        this.nombreTextoPrincipal = "Nombre, arma un plan a tu medida";
        this.textoInferior = "Selecciona las coberturas que quieres incluir";
      }
    });

    // ✅ Clonar dataCarga para no modificar el original
    const bodyForPlanes = JSON.parse(JSON.stringify(this.dataCarga));
    bodyForPlanes.getPriceData = true;
    bodyForPlanes.productsConfigurationData.Property = {
      TemporaryContracted: '6',
      AdministrationValue: this.datosGenerales.InfoArrendamiento.valorAdministracion,
      RentalFee: this.datosGenerales.InfoArrendamiento.valorArriendo,
      // ✅ Campos quemados solo para la petición de planes
      Department: "Meta",
      CityProperty: "Villavicencio"
    };

    this.orquestadorService.postOrquestadorPlanes(bodyForPlanes).
      subscribe(
        (data) => {
          this.planes = data;
          this.servicioPublico = this.planes.data[0].coverages[1].price;
          this.paqueteAsistencia = this.planes.data[0].coverages[2].price;
          this.canonArrendamiento = this.planes.data[0].coverages[0].price;
          this.valorPlan = this.datosGenerales.InfoArrendamiento.valorArriendo * 0.35;
        },
        (error) => {
          console.error('❌ Error al obtener planes:', error);

          // ✅ Verificar si el error es 500 (Internal Server Error)
          if (error?.status === 500) {
            console.error('🚨 Error 500 detectado - Redirigiendo a página de error...');
            this.router.navigate([ERROR_500_REDIRECT]);
            return;
          }

          // Para otros errores, mantener comportamiento anterior (redirigir a ERROR)
          this.router.navigate([ERROR, { porcPll: '25', msnPll: 'Tipo de Propiedad comercial seleccionada.', infoViaje: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
          return;
        }
      );
  }

  ngOnDestroy(): void {
    this.saliendo = true;
    clearInterval(this.isMouseMove);
    clearTimeout(this.checador);
  }

  checkChangeHandler(event: any, check: number) {
    if (check == 1) {
      if (event.target.value == 'on' && this.swCheckServicio == false) {
        this.swCheckServicio = true;
        this.valorPlan = this.valorPlan + this.servicioPublico;
      }
      else {
        this.swCheckServicio = false;
        this.valorPlan = this.valorPlan - this.servicioPublico;
      }
    }

    if (check == 2) {
      if (event.target.value == 'on' && this.swCheckAsistencia == false) {
        this.swCheckAsistencia = true;
        this.valorPlan = this.valorPlan + this.paqueteAsistencia;
      }
      else {
        this.swCheckAsistencia = false;
        this.valorPlan = this.valorPlan - this.paqueteAsistencia;
      }
    }
  }

  continuar() {
    this.datosGenerales.InfoArrendamiento.ServiciosPublicos = this.swCheckServicio;
    this.datosGenerales.InfoArrendamiento.PaquetesAsistencia = this.swCheckAsistencia;
    this.parametro = JSON.stringify(this.datosGenerales);

    this._dataLayerService.logPlanes('ecommerce_step_4', 'Arrendamiento', 'Planes',
      this.sessionId, this.datosGenerales.InfoArrendamiento.valorArriendo.toString(),
      this.datosGenerales.InfoArrendamiento.valorAdministracion.toString(),
      this.datosGenerales.InfoArrendamiento.tipoPropiedad,
      this.datosGenerales.InfoArrendamiento.ubicacion, this.datosGenerales.InfoArrendamiento.ubicacion,
      '6',
      this.datosGenerales.InfoArrendamiento.fechaContrato, 'Arma tu plan sin inquilino',
      this.valorPlan.toString(), this.datosGenerales.InfoArrendamiento.ServiciosPublicos ? 'true' : 'false',
      this.datosGenerales.InfoArrendamiento.PaquetesAsistencia ? 'true' : 'false');

    this.router.navigate([FIN_FLUJO_NO, { codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
  }

  PagoPlan(): void {
    this.router.navigate([RESUMEN_COMPRA, { codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
  }
}
